/** Free driving on the shared ocean, with small-boat traffic but no cargo or objectives. */
import { Group, Vector3 } from 'three/webgpu'
import type { GameMode, ModeContext } from './GameMode.ts'
import { OpenWaterIslands } from '../world/OpenWaterIslands.ts'
import type { Obstacle } from '../world/Obstacle.ts'

export class OpenWaterMode implements GameMode {
  readonly worldGroup = new Group()
  readonly tugSpawn = { position: new Vector3(0, 0, 0), heading: 0 }
  private readonly islands = new OpenWaterIslands()

  constructor(private readonly ctx: ModeContext) {
    this.worldGroup.name = 'open-water'
    this.worldGroup.add(this.islands.group)
  }

  get trafficObstacles(): readonly Obstacle[] { return this.islands.obstacles }

  start(): void {
    this.ctx.tug.bedSampler = null
    this.ctx.tug.config.groundFriction = 0
    this.frame()
  }

  fixedStep(): void {
    this.ctx.tug.resolveCollisions(this.islands.obstacles)
  }
  toggleHook(): void {}

  frame(): void {
    const { tug, waypoint, chase, hud } = this.ctx
    waypoint.update(tug.position, null, chase.camera)
    hud.setHookState(false, false)
  }

  towWake(): null { return null }

  dispose(): void {
    this.ctx.scene.remove(this.worldGroup)
    this.islands.dispose()
    this.worldGroup.clear()
  }
}
